import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    staticClass: "status-tabs mb-5"
  }, [_c('div', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v(_vm._s(_vm.t('仓库')) + _vm._s(_vm.t('common', '：')))]), _c('a-tabs', {
    attrs: {
      "size": "small",
      "animated": false,
      "data-sign": "batch_inventory_owner_batch_inventory_tab"
    },
    on: {
      "change": _vm.handleTabChange
    },
    model: {
      value: _vm.searchData.warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "warehouse_code", $$v);
      },
      expression: "searchData.warehouse_code"
    }
  }, [_c('a-tab-pane', {
    key: undefined,
    attrs: {
      "fbu-analyse-name": $t("\u5168\u90E8"),
      "tab": _vm.t('common', '全部')
    }
  }), _vm._l(_vm.warehouseList, function (item) {
    return _c('a-tab-pane', {
      key: item.warehouse_code
    }, [_c('div', {
      attrs: {
        "slot": "tab"
      },
      slot: "tab"
    }, [item.is_used ? _c('span', [_vm._v(_vm._s(item.warehouse_name_text))]) : _c('a-tooltip', {
      attrs: {
        "overlayClassName": "expandTooltip"
      }
    }, [_c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.tc('仓库未开通')))]), _c('span', {
      staticStyle: {
        "color": "#ddd"
      }
    }, [_vm._v(_vm._s(item.warehouse_name_text))])])], 1)]);
  })], 2)], 1), _c('my-enter-search', {
    staticClass: "mb-10",
    attrs: {
      "data-sign": "batch_inventory_owner_batch_inventory_form"
    },
    on: {
      "search": _vm.handleSearch
    }
  }, [_c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "allow-clear": false
    },
    model: {
      value: _vm.codeField,
      callback: function ($$v) {
        _vm.codeField = $$v;
      },
      expression: "codeField"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": "product_sku"
    }
  }, [_vm._v(_vm._s(_vm.t('商品编码')))]), _c('a-select-option', {
    attrs: {
      "value": "reference_no"
    }
  }, [_vm._v(_vm._s(_vm.t('参考编码')))]), _c('a-select-option', {
    attrs: {
      "value": "product_barcode"
    }
  }, [_vm._v(_vm._s(_vm.t('谷仓商品条码')))]), _c('a-select-option', {
    attrs: {
      "value": "product_title"
    }
  }, [_vm._v(_vm._s(_vm.t('商品中文名')))]), _c('a-select-option', {
    attrs: {
      "value": "product_title_en"
    }
  }, [_vm._v(_vm._s(_vm.t('商品英文名称')))])], 1), _c('a-input', {
    staticClass: "form-item-input",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u53CC\u51FB\u53EF\u6279\u91CF\u67E5\u8BE2"),
      "data-sign": "batch_inventory_owner_batch_inventory_dblclick",
      "placeholder": _vm.isProductCodeField() ? _vm.t('common', '双击可批量查询') : _vm.t('请输入')
    },
    on: {
      "dblclick": _vm.handleDblClick
    },
    model: {
      value: _vm.docValue,
      callback: function ($$v) {
        _vm.docValue = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "docValue"
    }
  }, [_c('div', {
    attrs: {
      "slot": "addonAfter"
    },
    slot: "addonAfter"
  }, [_c('a-popover', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(_vm._s(_vm.t(_vm.isAccurate ? $t("\u7CBE\u786E\u67E5\u8BE2") : $t("\u6A21\u7CCA\u67E5\u8BE2"))))]), _c('a-checkbox', {
    attrs: {
      "data-sign": "batch_inventory_owner_batch_inventory_is_accurate"
    },
    on: {
      "change": _vm.handleSearchWayChange
    },
    model: {
      value: _vm.isAccurate,
      callback: function ($$v) {
        _vm.isAccurate = $$v;
      },
      expression: "isAccurate"
    }
  }), _vm._v(" " + _vm._s(_vm.t(_vm.isAccurate ? $t("\u7CBE\u786E") : $t("\u6A21\u7CCA"))) + " ")], 1)], 1)])], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-analyse-name": $t("\u5E93\u5B58\u7C7B\u578B"),
      "allow-clear": false,
      "placeholder": _vm.t('库存类型')
    },
    model: {
      value: _vm.searchData.inventory_type,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "inventory_type", $$v);
      },
      expression: "searchData.inventory_type"
    }
  }, _vm._l(_vm.inventoryTypeEnum, function (item, index) {
    return _c('a-select-option', {
      key: index,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.text))]);
  }), 1), _vm.searchData.inventory_type && _vm.checkShowProductQuality(_vm.searchData.inventory_type) ? _c('my-select', {
    staticClass: "form-item-select",
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5546\u54C1\u54C1\u8D28"),
      "data-sign": "batch_inventory_owner_batch_inventory_product_quanlity",
      "placeholder": _vm.t('商品品质'),
      "show-search": "",
      "show-tip": "",
      "allowClear": ""
    },
    model: {
      value: _vm.searchData.product_quanlity,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "product_quanlity", $$v);
      },
      expression: "searchData.product_quanlity"
    }
  }, _vm._l(_vm.orderProductQualityEnum, function (item) {
    return _c('a-select-option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1) : _vm._e(), _c('a-input-number', {
    staticStyle: {
      "width": "100px",
      "text-align": "center"
    },
    attrs: {
      "data-sign": "batch_inventory_owner_batch_inventory_inventory_type_min",
      "min": 0,
      "max": 999999999,
      "placeholder": ""
    },
    model: {
      value: _vm.searchData.inventory_type_min,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "inventory_type_min", $$v);
      },
      expression: "searchData.inventory_type_min"
    }
  }), _c('a-input', {
    staticStyle: {
      "width": "30px",
      "border-left": "0",
      "pointer-events": "none",
      "backgroundColor": "#fff"
    },
    attrs: {
      "fbu-analyse-name":
      /*no-i18n-auto*/
      '~',
      "placeholder": "~",
      "disabled": ""
    }
  }), _c('a-input-number', {
    staticStyle: {
      "width": "100px",
      "text-align": "center",
      "border-left": "0"
    },
    attrs: {
      "data-sign": "batch_inventory_owner_batch_inventory_inventory_type_max",
      "min": 0,
      "max": 999999999,
      "placeholder": ""
    },
    model: {
      value: _vm.searchData.inventory_type_max,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "inventory_type_max", $$v);
      },
      expression: "searchData.inventory_type_max"
    }
  })], 1), _c('a-input-group', {
    staticClass: "form-item-inline",
    attrs: {
      "compact": ""
    }
  }, [_c('a-input', {
    staticClass: "form-item-input",
    attrs: {
      "fbu-analyse-name": $t("\u8D27\u4E3B\u6279\u6B21"),
      "maxLength": 100,
      "allow-clear": true,
      "placeholder": _vm.t('货主批次')
    },
    model: {
      value: _vm.searchData.consignor_batch_list,
      callback: function ($$v) {
        _vm.$set(_vm.searchData, "consignor_batch_list", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "searchData.consignor_batch_list"
    }
  })], 1), _c('span', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('a-button', {
    attrs: {
      "ghost": "",
      "type": "primary",
      "data-sign": "batch_inventory_owner_batch_inventory_search",
      "fbu-analyse-name": $t("\u641C\u7D22")
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "search"
    }
  }), _vm._v(_vm._s(_vm.t('搜索')) + " ")], 1), _c('a-button', {
    staticClass: "ml-10",
    attrs: {
      "data-sign": "batch_inventory_owner_batch_inventory_reset",
      "fbu-analyse-name": $t("\u91CD\u7F6E")
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v(_vm._s(_vm.t('重置')))])], 1)], 1), _c('div', {
    staticClass: "mb-15"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('已选')) + _vm._s(_vm.t('common', ':')) + " " + _vm._s(_vm.selectedIdList.length))]), _c('a-dropdown', {
    attrs: {
      "data-sign": "batch_inventory_owner_batch_inventory_export"
    }
  }, [_c('a-menu', {
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('a-menu-item', {
    key: "1",
    attrs: {
      "data-sign": "batch_inventory_owner_batch_inventory_export_all",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5168\u90E8")
    },
    on: {
      "click": _vm.handleExportAll
    }
  }, [_vm._v(_vm._s(_vm.t('导出全部')))]), _c('a-menu-item', {
    key: "2",
    attrs: {
      "data-sign": "batch_inventory_owner_batch_inventory_export_selected",
      "fbu-analyse-name": $t("\u5BFC\u51FA\u5DF2\u9009")
    },
    on: {
      "click": _vm.handleExportSelected
    }
  }, [_vm._v(_vm._s(_vm.t('导出已选')))])], 1), _c('a-button', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "fbu-analyse-name": $t("\u5BFC\u51FA")
    }
  }, [_vm._v(_vm._s(_vm.t('导出')) + " "), _c('a-icon', {
    attrs: {
      "type": "down"
    }
  })], 1)], 1)], 1), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('resize-table', {
    attrs: {
      "bordered": "",
      "columns": _vm.columns,
      "fixed-header": "",
      "useMouseTool": "",
      "is-filter-box": "",
      "name": "batchInventoryOwnerBatchInventoryList",
      "data-sign": "batch_inventory_owner_batch_inventory_table",
      "row-selection": _vm.rowSelection,
      "data-source": _vm.dataList,
      "row-key": "id"
    },
    on: {
      "change": _vm.handleSortChange
    },
    scopedSlots: _vm._u([{
      key: "product_sku",
      fn: function (ref) {
        var record = ref.record;
        return [_c('router-link', {
          directives: [{
            name: "copy2",
            rawName: "v-copy2",
            value: record.product_sku,
            expression: "record.product_sku"
          }],
          attrs: {
            "to": {
              name: 'ProductDetail',
              query: {
                sku: record.product_sku,
                name: _vm.$route.name
              },
              params: {
                noCache: 1
              }
            },
            "data-sign": "batch_inventory_owner_batch_inventory_product_sku"
          }
        }, [_vm._v(" " + _vm._s(record.product_sku) + " ")])];
      }
    }, {
      key: "product_title",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_c('text-ellipses', {
          attrs: {
            "data": record.product_title
          }
        })], 1);
      }
    }, {
      key: "warehouse_code",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {}, [_vm._v(" " + _vm._s(record.warehouse_name) + "[" + _vm._s(record.warehouse_code) + "] ")]);
      }
    }, {
      key: "product_quanlity_text",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {
          staticClass: "table-inside-box",
          staticStyle: {
            "width": "100%"
          }
        }, [_c('div', {
          staticClass: "table-inside-cell",
          staticStyle: {
            "height": "100%"
          }
        }, [_vm.product_quanlity !== _vm.$enum.product.ProductQualityEnum.BAD ? _c('ul', {
          staticClass: "table-inside-row"
        }, [_c('li', {
          staticClass: "table-inside-td table-align-left"
        }, [_vm._v(" " + _vm._s(_vm.t('良品')) + " ")])]) : _vm._e(), _vm.product_quanlity !== _vm.$enum.product.ProductQualityEnum.GOOD ? _c('ul', {
          staticClass: "table-inside-row"
        }, [_c('li', {
          staticClass: "table-inside-td table-align-left",
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(" " + _vm._s(_vm.t('不良品')) + " ")])]) : _vm._e()])]);
      }
    }, {
      key: "reserved_quantity",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {
          staticClass: "table-inside-box",
          staticStyle: {
            "width": "100%",
            "min-width": "150px"
          }
        }, [_c('div', {
          staticClass: "table-inside-cell",
          staticStyle: {
            "height": "100%"
          }
        }, [_vm.product_quanlity !== _vm.$enum.product.ProductQualityEnum.BAD ? _c('ul', {
          staticClass: "table-inside-row"
        }, [_c('li', {
          staticClass: "table-inside-td"
        }, [record.reserved_quantity > 0 ? _c('a', {
          attrs: {
            "href": "javascript:"
          },
          on: {
            "click": function ($event) {
              return _vm.handleReservedDetail(record, _vm.$enum.product.ProductQualityEnum.GOOD);
            }
          }
        }, [_vm._v(_vm._s(record.reserved_quantity))]) : _c('span', [_vm._v(_vm._s(record.reserved_quantity))])])]) : _vm._e(), _vm.product_quanlity !== _vm.$enum.product.ProductQualityEnum.GOOD ? _c('ul', {
          staticClass: "table-inside-row"
        }, [_c('li', {
          staticClass: "table-inside-td"
        }, [record.unsellable_reserved > 0 ? _c('a', {
          attrs: {
            "href": "javascript:"
          },
          on: {
            "click": function ($event) {
              return _vm.handleReservedDetail(record, _vm.$enum.product.ProductQualityEnum.BAD);
            }
          }
        }, [_vm._v(_vm._s(record.unsellable_reserved))]) : _c('span', [_vm._v(_vm._s(record.unsellable_reserved))])])]) : _vm._e()])]);
      }
    }, {
      key: "sellable_quantity",
      fn: function (ref) {
        var record = ref.record;
        return _c('div', {
          staticClass: "table-inside-box",
          staticStyle: {
            "width": "100%",
            "min-width": "150px"
          }
        }, [_c('div', {
          staticClass: "table-inside-cell",
          staticStyle: {
            "height": "100%"
          }
        }, [_vm.product_quanlity !== _vm.$enum.product.ProductQualityEnum.BAD ? _c('ul', {
          staticClass: "table-inside-row"
        }, [_c('li', {
          staticClass: "table-inside-td"
        }, [_vm._v(" " + _vm._s(record.sellable_quantity) + " ")])]) : _vm._e(), _vm.product_quanlity !== _vm.$enum.product.ProductQualityEnum.GOOD ? _c('ul', {
          staticClass: "table-inside-row"
        }, [_c('li', {
          staticClass: "table-inside-td"
        }, [_vm._v(" " + _vm._s(record.unsellable_quantity) + " ")])]) : _vm._e()])]);
      }
    }])
  })], 1), _c('my-pagination', {
    staticClass: "mt-20",
    attrs: {
      "isFixed": "",
      "value": _vm.searchData.page_index,
      "name": "batchInventoryOwnerBatchInventoryList",
      "total": _vm.total,
      "page-size": _vm.searchData.page_size
    },
    on: {
      "update:pageSize": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "update:page-size": function ($event) {
        return _vm.$set(_vm.searchData, "page_size", $event);
      },
      "onChange": _vm.handlePageChange
    }
  }), _c('bulk-search-modal', {
    ref: "bulkSearchModal",
    on: {
      "bulkSearch": _vm.handleBulkFeedback
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };